module.exports = __webpack_public_path__ + "img/ic_sorting.f39269f1.svg";